import { NameLocalized } from './nameLocalized';
import { Author } from '../../user/objects/author';
import { Network } from '../../network/objects/network';
import { Provider } from '../../provider/objects/provider';
import { Currency } from '../../currency/objects/currency';
import { IataAirline } from '../../iata/objects/iataAirline';
import { DestinationReduced } from '../../destination/objects/destinationReduced';
import { CentralPayment } from '../../centralPayment/objects/centralPayment';
import { ClientBranchCompany } from './company';
import { IataCity } from '../../iata/objects/iataCity';
import { IataCountry } from '../../iata/objects/iataCountry';
import { MarginFlightCabin, MarginFlightSource, MarginFlightTariffType } from '../../marginFlight/objects/flightSpecificLevel';

export enum MarginBookingEngine {
    "CIRCUIT" = "CIRCUIT",
    "TAILOR_MADE" = "TAILOR_MADE",
    "FLIGHT" = "FLIGHT"
}

export type Margin = {
    applied_under_amount: null | number,
    client_branch: ClientBranchCompany[],
    children: null | Margin[],
    commissioned_agency: null,
    content_types: number[],
    created_date: string,
    creator: Author,
    currency_rate: null | Currency,
    destinations: DestinationReduced[],
    disabled_date: null | string,
    end_date: null | string,
    // flight_specifics_levels: FlightSpecificLevel[],
    id: number,
    is_surcom: boolean,
    is_tva: boolean,
    tva_margin_only?: boolean | null,
    last_author: null | Author,
    localization: NameLocalized[],
    modified_date: string,
    name: string,
    network: null | Network,
    payment_center?: null | CentralPayment,
    owner: number,
    providers: Provider[],
    rate: string,
    start_date: null | string,
    type_rate: 'PER' | 'FIX',
    from_client?: number,
    booking_engines: MarginBookingEngine[],
    cms: ("B2B" | "B2C")[],
    is_markup?: boolean,


    flight_class_booking: string[];
    flight_fare_basis: string[];
    extra_type: 'BAGGAGE' | 'SEAT';
    iata_airline: IataAirline[];
    iata_city: IataCity[];
    iata_country: IataCountry[];

    flight_tariff_type: MarginFlightTariffType[];
    flight_source: MarginFlightSource[];
    flight_cabin: MarginFlightCabin[];

    is_infant: boolean;
    flight_is_tax: boolean;
    flight_is_fee_tax: boolean;

    is_multi_condition: boolean;
    level_index: number | null;
    is_multi_specifics: string | null;

    trip_creation_start_date: null | Date;
    trip_creation_end_date: null | Date;
}